import { TextField } from "@mui/material";
import { styled as MuiStyled } from "@mui/system";

export const TextFieldContainer = MuiStyled(TextField)(() => {
    return {
      "&:not(:last-of-type)": {
        marginBottom: '32px',
      },
    
      ".MuiFormHelperText-root": {
        marginLeft: "auto",
      }
    }
})